import * as React from 'react';
import { WithStyles, FormControl, Button, Theme, createStyles, withStyles, TextField, Typography, CircularProgress } from '@material-ui/core';
import strings from 'src/strings';
import { UsersAPI, errorToString } from 'src/api';
import { withToast, WithToast } from 'src/components/HOC/Toast';
import classNames from 'classnames';

export interface ChangePasswordState {
    oldPW?: string,
    newPw?: string,
}

export interface ChangePasswordProps extends ChangePasswordState {
    className?: string;
}

class ChangePassword extends React.Component<ChangePasswordProps & WithStyles<typeof styles> & WithToast, ChangePasswordState & {
    errors: {
        new: boolean,
        old: boolean
    },
    loading: boolean
}> {


    constructor(props: ChangePasswordProps & WithStyles<typeof styles> & WithToast) {
        super(props)
        this.state = {
            errors: {
                new: false,
                old: false,
            },
            loading: false
        }
    }

    handleNewDidChange = (pw: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ newPw: pw.currentTarget.value });
    };
    handleOldDidChange = (pw: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ oldPW: pw.currentTarget.value });
    };

    handleNewPassword(state: ChangePasswordState) {
        UsersAPI.changePassword(state.oldPW!, state.newPw!).then((user) => {
            this.setState({ loading: false, oldPW: '', newPw: '' })
            this.props.showToast('success', 'Changed Password!')
        }).catch(err => {
            this.setState({ loading: false })
            errorToString(err).forEach(error => {
                this.props.showToast('error', error)
            })
        })
    }

    handleDone = () => {
        if (!this.state.oldPW) {
            this.setState({ errors: { new: false, old: true } })
        } else if (!this.state.newPw) {
            this.setState({ errors: { new: true, old: false } })
        } else {
            this.setState({ errors: { new: false, old: false }, loading: true })
            this.handleNewPassword(this.state)
        }
    }

    public render() {
        const { oldPW, newPw } = this.state;
        return (
            <div className={classNames(this.props.classes.container, this.props.className || '')}>
                <FormControl fullWidth>
                    <TextField value={oldPW} onChange={this.handleOldDidChange} label='Old Password' type='password' error={this.state.errors.old} />
                </FormControl>
                <FormControl fullWidth className={this.props.classes.formControlPadding}>
                    <TextField value={newPw} onChange={this.handleNewDidChange} label='New Password' type='password' error={this.state.errors.old} />
                </FormControl>
                <div className={this.props.classes.buttons}>
                    <Button variant='outlined' color='secondary' onClick={this.handleDone}>
                        {this.state.loading ? <CircularProgress size={24} color='inherit' /> : strings.done}
                    </Button>
                </div>
            </div>
        )
    }

}

const styles = (theme: Theme) => createStyles({
    buttons: {
        paddingTop: 20,
        display: 'flex',
        justifyContent: 'flex-end',
    },
    formControlPadding: {
        paddingTop: theme.spacing()
    },
    container: {
    }
})

export default withToast(withStyles(styles)(ChangePassword))


// WEBPACK FOOTER //
// ./src/components/Settings/ChangePassword/ChangePassword.tsx